import { render, staticRenderFns } from "./rightTree.vue?vue&type=template&id=605c6425&scoped=true&"
import script from "./rightTree.vue?vue&type=script&lang=js&"
export * from "./rightTree.vue?vue&type=script&lang=js&"
import style0 from "./rightTree.vue?vue&type=style&index=0&id=605c6425&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c6425",
  null
  
)

export default component.exports